import styled, { css } from 'styled-components';

import { breakpoints } from '@notino/react-styleguide';

import { IExpandableText } from './model';

export const ExpandableTextWrapper = styled.div<
  Pick<IExpandableText, 'shouldShowFullText'> & { newDesign: boolean }
>`
  height: ${({ shouldShowFullText }) =>
    shouldShowFullText ? 'auto' : '5.5rem'};
  overflow: ${({ shouldShowFullText }) =>
    shouldShowFullText ? 'auto' : 'hidden'};

  position: relative;

  @media (min-width: ${breakpoints.lg}) {
    height: auto;
    overflow: auto;
  }

  ${({ newDesign }) =>
    newDesign &&
    css`
      @media (min-width: ${breakpoints.lg}) {
        padding-right: 2rem;
      }
    `}
`;

export const Gradient = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  );

  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;

export const ExpandableTextButton = styled.button<{
  newPdDesignEnabled: boolean;
}>`
  background: none;
  border: none;
  text-decoration: underline;
  cursor: pointer;
  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          margin-bottom: -1rem;
          padding-top: 1.5rem;
        `
      : 'padding: 1.5rem 0rem'};
  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`;
